(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awillc-christmas-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
function initialize(root){
if(root.dataset.ready)return;
root.dataset.ready='true';
const slides=Array.from(root.querySelectorAll('[data-slide]'));
const next=root.querySelector('[data-next]'),prev=root.querySelector('[data-prev]'),play=root.querySelector('[data-play]'),counter=root.querySelector('[data-counter]');
if(!next||slides.length<2)return;
let current=0,timer=null,playing=false,touchStart=null;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
function display(index){
slides[current].hidden=true;slides[current].classList.remove('is-active','is-entering');
current=(index+slides.length)%slides.length;
slides[current].hidden=false;slides[current].classList.add('is-active','is-entering');
counter.textContent=String(current+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
}
function stopTimer(){if(timer){clearInterval(timer);timer=null;}}
function resume(){stopTimer();if(playing&&!document.hidden)timer=setInterval(()=>display(current+1),8500);}
function pause(){playing=false;stopTimer();play.setAttribute('aria-pressed','false');play.setAttribute('aria-label',play.dataset.playLabel);play.textContent='▶';}
next.addEventListener('click',()=>{pause();display(current+1);});
prev.addEventListener('click',()=>{pause();display(current-1);});
play.addEventListener('click',()=>{if(playing){pause();return;}playing=true;play.setAttribute('aria-pressed','true');play.setAttribute('aria-label',play.dataset.pauseLabel);play.textContent='Ⅱ';resume();});
root.addEventListener('mouseenter',stopTimer);
root.addEventListener('mouseleave',resume);
root.addEventListener('focusin',stopTimer);
root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))resume();});
document.addEventListener('visibilitychange',()=>document.hidden?stopTimer():resume());
root.querySelector('.awi-stage').addEventListener('touchstart',e=>{touchStart=e.changedTouches[0].clientX;},{passive:true});
root.querySelector('.awi-stage').addEventListener('touchend',e=>{if(touchStart===null)return;const delta=e.changedTouches[0].clientX-touchStart;touchStart=null;if(Math.abs(delta)>60){pause();display(current+(delta<0?1:-1));}},{passive:true});
root.addEventListener('keydown',e=>{if(e.target.closest('button')&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){e.preventDefault();pause();display(current+(e.key==='ArrowRight'?1:-1));}});
reduced.addEventListener('change',pause);
document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))stopTimer();});
}
document.querySelectorAll('[data-awi-slider]').forEach(initialize);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-awi-slider]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awillc-simple-header"]) return;
  try {
    
function awiBannerInit(root){
if(root.dataset.ready)return;
root.dataset.ready='true';
const toggle=root.querySelector('.awi-banner-toggle');
toggle.addEventListener('click',()=>{
const paused=root.classList.toggle('is-paused');
toggle.setAttribute('aria-pressed',String(paused));
toggle.setAttribute('aria-label',paused?toggle.dataset.play:toggle.dataset.pause);
toggle.textContent=paused?'▶':'Ⅱ';
});
}
document.querySelectorAll('[data-awi-banner]').forEach(awiBannerInit);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-awi-banner]').forEach(awiBannerInit));

document.querySelectorAll('.awi-header nav').forEach(nav=>{
  nav.querySelectorAll('.awi-nav-group').forEach(group=>{
    group.addEventListener('toggle',()=>{
      if(group.open)nav.querySelectorAll('.awi-nav-group[open]').forEach(other=>{if(other!==group)other.open=false;});
    });
  });
  nav.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      const group=event.target.closest('.awi-nav-group[open]');
      if(group){group.open=false;group.querySelector('summary').focus();}
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
